import { Skeleton } from '@mui/material';
import { MilestoneStatusResponses, MilestoneTypes } from '../../models';
import { CerebroText } from '../CerebroText';
import { MilestoneIcon } from './MilestoneIcon';

interface DirectConnectMilestoneStatusItemProps {
	display: string;
	isFetching: boolean;
	size: number;
	type: MilestoneTypes;
	response?: MilestoneStatusResponses;
	onClick: () => void;
}

export const DirectConnectMilestoneStatusItem: React.FC<DirectConnectMilestoneStatusItemProps> = ({
	display,
	isFetching,
	size,
	type,
	response,
	onClick,
}) => {
	const isComplete = response == 'Yes';

	return (
		<>
			<CerebroText variant="small" gutterBottom align="center" weight="medium">
				{display}
			</CerebroText>

			{isFetching ? (
				<Skeleton animation="wave" sx={theme => ({ backgroundColor: theme.palette.primary.light })} />
			) : (
				<div
					onClick={isComplete ? undefined : onClick}
					style={{ cursor: isComplete ? 'default' : 'pointer', display: 'inline-block' }}
				>
					<MilestoneIcon size={size} type={type} inProgress={false} response={response} />
				</div>
			)}
		</>
	);
};
